/* Trendybed — theme.js
   Globale UI: cart-drawer open/dicht, mobiel menu, predictive search.
   Cart-mutaties staan in cart.js. */
(function () {
  "use strict";

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* ---------- Cart-drawer open/dicht ---------- */
  const drawer = document.getElementById("CartDrawer");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    const panel = drawer.querySelector(".cart-drawer__panel");
    if (panel) panel.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  window.TrendybedCart = window.TrendybedCart || {};
  window.TrendybedCart.open = openDrawer;
  window.TrendybedCart.close = closeDrawer;

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-close]")) closeDrawer();
    if (e.target.closest("[data-cart-toggle]")) {
      e.preventDefault();
      openDrawer();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      closeDrawer();
      closeMobileNav();
    }
  });

  /* ---------- Mobiel menu ---------- */
  const mobileNav = document.getElementById("MobileNav");
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove("is-open");
    document.body.classList.remove("nav-open");
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-nav-toggle]")) {
      e.preventDefault();
      if (mobileNav) mobileNav.classList.toggle("is-open");
      document.body.classList.toggle("nav-open");
    }
    if (e.target.closest("[data-nav-close]")) closeMobileNav();
  });

  /* ---------- Zoekbalk toggle ---------- */
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-search-toggle]")) {
      e.preventDefault();
      const panel = document.querySelector("[data-search-panel]");
      if (panel) {
        panel.hidden = !panel.hidden;
        if (!panel.hidden) {
          const input = panel.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      }
    }
  });

  /* ---------- Predictive search ---------- */
  const searchForms = document.querySelectorAll("[data-predictive-search]");
  searchForms.forEach(function (form) {
    const input = form.querySelector('input[type="search"], input[name="q"]');
    const results = form.querySelector("[data-predictive-results]");
    if (!input || !results) return;
    let timer;

    input.addEventListener("input", function () {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = "";
        results.hidden = true;
        return;
      }
      timer = setTimeout(function () {
        const url =
          root +
          "search/suggest.json?q=" +
          encodeURIComponent(q) +
          "&resources[type]=product,collection,article&resources[limit]=6&section_id=predictive-search";
        // JSON-variant voor snelle suggesties
        fetch(
          root +
            "search/suggest.json?q=" +
            encodeURIComponent(q) +
            "&resources[type]=product&resources[limit]=6"
        )
          .then((r) => r.json())
          .then((data) => renderSuggestions(data, results, q))
          .catch(() => {});
      }, 220);
    });

    document.addEventListener("click", function (e) {
      if (!form.contains(e.target)) {
        results.hidden = true;
      }
    });
  });

  function renderSuggestions(data, container, q) {
    const products = (data.resources && data.resources.results && data.resources.results.products) || [];
    if (!products.length) {
      container.innerHTML = '<p class="predictive-empty">Geen resultaten voor &ldquo;' + escapeHtml(q) + "&rdquo;</p>";
      container.hidden = false;
      return;
    }
    const html = products
      .map(function (p) {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        return (
          '<a class="predictive-item" href="' +
          p.url +
          '">' +
          (img ? '<img src="' + img + '" alt="" width="44" height="55" loading="lazy">' : "") +
          '<span class="predictive-item__title">' +
          escapeHtml(p.title) +
          "</span>" +
          (p.price ? '<span class="price">' + p.price + "</span>" : "") +
          "</a>"
        );
      })
      .join("");
    container.innerHTML = html;
    container.hidden = false;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- Recently viewed (localStorage) ---------- */
  window.TrendybedRecentlyViewed = {
    key: "trendybed:recently-viewed",
    push: function (handle) {
      if (!handle) return;
      let list = this.get();
      list = list.filter((h) => h !== handle);
      list.unshift(handle);
      list = list.slice(0, 12);
      try {
        localStorage.setItem(this.key, JSON.stringify(list));
      } catch (e) {}
    },
    get: function () {
      try {
        return JSON.parse(localStorage.getItem(this.key) || "[]");
      } catch (e) {
        return [];
      }
    },
  };
})();
